// extracted by mini-css-extract-plugin
export default {"userTabDetail":"UserTabDetail_userTabDetail__zOdrh","listGroupTitle":"UserTabDetail_listGroupTitle__-1Eqh","loader":"UserTabDetail_loader__aNMB3"};